import { FC, useMemo } from 'react';

import { useQueryParamContext } from './QueryParamContext';
import { useCampaignById } from '../hooks/useCampaignById';
import { CampaignQueryContext, CampaignQueryContextState } from './CampaignQueryContext';

export const CampaignQueryContextProvider: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const { campaignId } = useQueryParamContext();

  const queryOptions = useMemo(
    () => ({
      skip: campaignId === 0,
      variables: { campaignId },
    }),
    [campaignId],
  );

  const Campaign = useCampaignById(queryOptions);

  const { errorMessage = '', hasError, isLoading, refetch, results } = Campaign;

  const refetchCampaign = () => {
    refetch({ campaignId });
  };

  const context: CampaignQueryContextState = {
    errorMessage,
    hasError,
    isLoading,
    refetch: refetchCampaign,
    campaign: results,
  };

  return <CampaignQueryContext.Provider value={context}>{children}</CampaignQueryContext.Provider>;
};
